import type * as Headless from '@headlessui/react';
import { skipToken } from '@reduxjs/toolkit/query';
import { forwardRef } from 'react';
import { Avatar, AvatarButton } from '@/primitives/avatar.tsx';
import type { Link } from '@/primitives/link.tsx';
import { useFetchFileUrlQuery } from '@/slices/file-upload-api-slice.ts';

type AvatarDisplayProps = {
  firstName: string;
  lastName: string;
  imageUrl: string;
  className: string;
  title?: string;
};

export const AvatarDisplay = ({
  firstName,
  lastName,
  imageUrl,
  className,
  title,
}: AvatarDisplayProps) => {
  const { data } = useFetchFileUrlQuery(imageUrl ?? skipToken);

  return (
    <Avatar
      title={title}
      initials={`${firstName?.substring(0, 1)}${lastName?.substring(0, 1)}`}
      className={className}
      src={data}
    />
  );
};

export const AvatarDisplayButton = forwardRef(function AvatarDisplayButton(
  {
    firstName,
    lastName,
    imageUrl,
    className,
    title,
    ...props
  }: AvatarDisplayProps &
    (
      | Omit<Headless.ButtonProps, 'as' | 'className'>
      | Omit<React.ComponentPropsWithoutRef<typeof Link>, 'className'>
    ),
  ref: React.ForwardedRef<HTMLElement>,
) {
  const { data } = useFetchFileUrlQuery(imageUrl ?? skipToken);

  return (
    <AvatarButton
      {...props}
      ref={ref}
      title={title}
      initials={`${firstName?.substring(0, 1)}${lastName?.substring(0, 1)}`}
      className={className}
      src={data}
    />
  );
});
